import { useContext } from "react";

import {
  ConfirmationDialogContext,
  ConfirmationDialogReturn,
} from "../contexts/ConfirmationDialogContext";

export const useConfirmationDialog = (): ConfirmationDialogReturn => {
  const context = useContext(ConfirmationDialogContext);
  if (!context) {
    throw new Error(
      "useConfirmationDialog must be used within a ConfirmationDialogProvider",
    );
  }
  return context;
};
